import React from 'react'
import PropTypes from 'prop-types'
import { Button, Icon } from 'semantic-ui-react'
import SupportModal from '../SupportModal/SupportModal.jsx'

const SupportButtonView = ({ showHelp, toggleHelpModal, shouldRender }) => {
  if (!shouldRender) return null

  return (
    <div className='support-button-overlay' color='green'>
      <Button primary onClick={toggleHelpModal}>
        <Icon circular name='mail' /> Contact Support{' '}
      </Button>
      {showHelp && <SupportModal open onClose={toggleHelpModal} />}
    </div>
  )
}

SupportButtonView.propTypes = {
  showHelp: PropTypes.bool.isRequired,
  toggleHelpModal: PropTypes.func.isRequired,
  shouldRender: PropTypes.bool.isRequired,
}

export default SupportButtonView
